export default __webpack_public_path__ + "Src/Client/Assets/assets.html";